<script setup>
import { ref } from "vue";
import { apiQuery } from "@/api/j24api";

var showReport = ref(false);
var loading = ref(false);

var popupPane = ref(false);
var popupTitle = ref("");
var popupMessage = ref("");

var report = ref([]);

async function getData() {
  report.value = await apiQuery("REPAIRS", "AuthorisationCheck", {
    type: "check",
  });
}

async function UpdateAccessToken(item) {
  let result = await apiQuery("REPAIRS", "AuthorisationCheck", {
    type: "update", // Type of request.
    name: item.Name, // Name so we can match the object at the other end.
    accessToken: item.GsxAccessToken,
  });

  if (result.response == "error") {
    popupTitle.value = "Error updating token";
    popupMessage.value = result.message;
    popupPane.value = true;
  } else {
    report.value = result;
    popupTitle.value = "Success";
    popupMessage.value = "Token has been updated";
    popupPane.value = true;
  }
}

function prefixUsername(user) {
  return "GSX Username - " + user;
}

async function checkAuth() {
  loading.value = true;
  await getData();

  if (report.value == undefined) {
    loading.value = false;
    popupTitle.value = "Error";
    popupMessage.value =
      "Error retrieving data. Please check the logs for more information.";
    popupPane.value = true;
    return;
  } else if (report.value.response == "error") {
    loading.value = false;
    popupTitle.value = "Error";
    popupMessage.value = report.value.message;
    popupPane.value = true;
    return;
  } else if (Object.keys(report.value).length === 0) {
    loading.value = false;
    popupTitle.value = "Error";
    popupMessage.value =
      "No data returned. Please check the logs for more information.";
    popupPane.value = true;
    return;
  } else {
    loading.value = false;
    showReport.value = true;
  }
}
</script>

<template>
  <v-btn
    @click="checkAuth"
    color="primary"
    :loading="loading"
    v-if="!showReport"
  >
    Perform Authentication Check
  </v-btn>
  <v-row v-if="showReport">
    <v-col md="6" v-for="item in report" :key="item.id">
      <v-card
        variant="elevated"
        class="mx-auto"
        :color="item.IsAuthed ? 'green-lighten-2' : 'red'"
        max-width="450"
        :title="item.Name"
        :subtitle="prefixUsername(item.GsxUser)"
      >
        <v-card-text>
          <v-text-field
            :disabled="item.IsAuthed"
            v-model="item.GsxAccessToken"
            variant="outlined"
          ></v-text-field>
          <v-btn
            text="Update"
            variant="outlined"
            :disabled="item.IsAuthed"
            @click="UpdateAccessToken(item)"
          ></v-btn>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <div class="text-center">
        <h3>Resetting Access Tokens</h3>
        <p>
          If any items are red, then the Access Token will need to be renewed.
        </p>
        <br />
        <ul>
          <p>
            1. Go
            <a href="https://login-partner-connect.apple.com/">here</a>
            for the production token, or
            <a href="https://login-partner-connect-uat.apple.com/">here</a>
            for the UAT token.
          </p>
          <p>
            2. Authenticate using the appropriate credentials. Please note the
            production token has MFA enabled, please speak to the repairs
            department if you need the code.
          </p>
          <p>
            3. Replace the expired code with the new Access Token and click
            Update. It should turn green if successful.
          </p>
        </ul>
      </div>
    </v-col>
  </v-row>

  <div class="text-center">
    <v-snackbar v-model="popupPane" vertical>
      <div class="text-subtitle-1 pb-2">{{ popupTitle }}</div>
      <p>{{ popupMessage }}</p>
      <template v-slot:actions>
        <v-btn color="primary" variant="elevated" @click="popupPane = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
